<script>
  export let exampleData;
  export let trigger;

  import { fade } from "svelte/transition";

  import { modalActive, windowHeight, onboarded } from "../../stores/global.js";
  import ModalContent from "./ModalContent.svelte";

  $: $modalActive == false
    ? window.document.body.classList.remove("modal-active")
    : window.document.body.classList.add("modal-active");

  $: sizeOfModal = 0.85;
  $: modalHeight = $windowHeight * sizeOfModal;

  // ONBOARDING USERS
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const showModal = async function () {
    await sleep(1500);
    modalActive.set(true);
  };

  $: if (trigger && $onboarded == "no") {
    showModal();
  }
  // When onboarded changes, show a new popup that reminds the user can reopen it, in the bottom right corner of our screen
  let reminderActive = false;
  const closeModal = async function () {
    modalActive.set(false);

    await sleep(400);
    onboarded.set("yes");
    reminderActive = true;

    await sleep(2600);
    reminderActive = false;
  };
</script>

{#if $modalActive}
  <div
    class="fullscreen-wait"
    transition:fade={{ duration: 300 }}
    style="height: {$windowHeight}px;"
  >
    <div class="modal" style="height: {modalHeight}px;">
      <div class="exit-button" on:click={closeModal}>x</div>
      <ModalContent {exampleData}
        ><button class="close-button" on:click={closeModal}>
          Okay, got it!
        </button></ModalContent
      >
    </div>
  </div>
{/if}
{#if reminderActive}
  <div transition:fade={{ duration: 400 }} class="reminder">
    You can always access me here!
  </div>
{/if}

<style>
  .fullscreen-wait {
    width: 100vw;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    z-index: 100;
    display: flex;
    place-items: center;
    justify-content: center;
  }

  .modal {
    background: #3d4682;
    color: white;
    position: relative;
    padding: 1rem;
    border-radius: 6px;
    width: 85vw;
    max-width: 960px;
    font-family: var(--font-small);
    overflow: hidden;
  }

  .exit-button {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 0.6rem 0.6rem 0.6rem;
    font-family: var(--font-subhead);
    font-size: 1.35rem;
  }

  :global(body) {
    overflow-y: auto;
  }

  :global(body.modal-active) {
    overflow-y: hidden;
  }

  .reminder {
    position: fixed;
    bottom: calc(2.5% + 40px);
    left: 6px;
    z-index: 10;
    font-size: 13px;
    text-align: center;
    background: rgba(0, 0, 0, 0.35);
    padding: 5px 8px;
    border-radius: 3px;
    box-shadow: 1px 1px 6px rgb(0, 0, 0, 0.15);
    font-family: var(--font-small);
    max-width: 100px;
    /* background: rgba(69, 119, 174, 0.75); */
  }

  .close-button {
    font-size: 1rem;
    background: #4575ac;
    text-align: center;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 auto;
    margin-top: 0.75rem;
    cursor: pointer;
    border: none;
    color: white;
    font-family: var(--font-subhead);
    text-transform: uppercase;
    font-weight: 300;
    letter-spacing: 0.6px;
    z-index: 20;
    height: 2.5rem;
  }

  .close-button:active {
    background: #4575ac;
  }

  @media screen and (max-width: 767px) {
    .close-button {
      font-size: 0.8rem;
      bottom: 5%;
    }

    .reminder {
      top: 3.75%;
      left: 40px;
      bottom: unset;
      font-size: 11px;
      max-width: none;
      /* background: rgba(61, 70, 130, 0.75); */
    }
  }
</style>
